/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  GetPouchResponseResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get specific historical version for a single pouch
 * @summary Get specific historical version for a single pouch
 */
export const getPouchidVersion = (versionID: string, signal?: AbortSignal) => {
  return customInstance<GetPouchResponseResponse>({
    url: `/bm-pouch-management/v1/pouch/history/${versionID}`,
    method: 'get',
    signal,
  });
};

export const getGetPouchidVersionQueryKey = (versionID: string) => {
  return [`/bm-pouch-management/v1/pouch/history/${versionID}`] as const;
};

export const getGetPouchidVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchidVersion>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  versionID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchidVersion>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchidVersionQueryKey(versionID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchidVersion>>> = ({ signal }) =>
    getPouchidVersion(versionID, signal);

  return { queryKey, queryFn, enabled: !!versionID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchidVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchidVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPouchidVersion>>
>;
export type GetPouchidVersionQueryError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Get specific historical version for a single pouch
 */
export const useGetPouchidVersion = <
  TData = Awaited<ReturnType<typeof getPouchidVersion>>,
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
>(
  versionID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchidVersion>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchidVersionQueryOptions(versionID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
